/**
 * Convert CSV string to JSON string
 * @param csv - The CSV string to convert
 * @param columnMapping - The column mapping to use
 * @returns The JSON string
 */
const csvToJson = (csv: string, columnMapping?: string[]): string => {
  const lines = csv
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);

  // Function to split a CSV line while respecting quotes
  const parseCsvLine = (line: string): string[] => {
    const regex = /("([^"]*)"|[^,]+|(?<=,)(?=,)|^$)/g;
    return Array.from(line.matchAll(regex), (match) => {
      let value = match[0] || "";
      if (value.startsWith('"') && value.endsWith('"')) {
        value = value.slice(1, -1).replace(/""/g, '"'); // Unescape double quotes
      }
      return value.trim();
    });
  };

  const headers = parseCsvLine(lines[0]);

  if (columnMapping) {
    const mappedHeaders = columnMapping.map((column) => {
      const headerIndex = headers.findIndex(
        (h) => h.toLowerCase() === column.toLowerCase()
      );
      if (headerIndex === -1) {
        throw new Error(`Header ${column} not found in CSV`);
      }
      return { name: headers[headerIndex], index: headerIndex };
    });

    const data = lines.slice(1).map((line) => {
      const values = parseCsvLine(line);
      return mappedHeaders.reduce((obj, header) => {
        obj[header.name] = values[header.index] || "-";
        return obj;
      }, {} as Record<string, string>);
    });

    return JSON.stringify(data);
  }

  const data = lines.slice(1).map((line) => {
    const values = parseCsvLine(line);
    return headers.reduce((obj, header, i) => {
      obj[header] = values[i] || "";
      return obj;
    }, {} as Record<string, string>);
  });

  return JSON.stringify(data);
};

export default csvToJson;
